import { useEffect, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

export const useIcdDisabledCases = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies } = filterParams;
    const { getData, isLoading } = useAxios();

    const [icdDisabledByCompany, setIcdDisabledByCompany] = useState([]);
    const [totalIcdDisabled, setTotalIcdDisabled] = useState(0);

    useEffect(() => {
        const fetchIcdDisabledCases = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;
            const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies });

            try {
                const response = await getData(`${baseUrl.icdDisabledCases}?${query}`);
                if (response?.success) {
                    setIcdDisabledByCompany(response?.data?.byCompany || []);
                    setTotalIcdDisabled(response?.data?.totalDisabled || 0);
                }
            } catch (err) {
                console.error("Failed to fetch ICD disabled cases", err);
                setIcdDisabledByCompany([]);
                setTotalIcdDisabled(0);
            }
        };

        fetchIcdDisabledCases();
    }, [selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies]);

    return {
        isIcdDisabledLoading: isLoading,
        totalIcdDisabled,
        icdDisabledByCompany
    };
};
